module.exports = __webpack_public_path__ + "static/media/SwasthLogo.e83718c1.png";